<template>
<div class="main my">
  <!-- 课表 -->
  <div class="model-box">

    <!-- 列表 -->
    <div v-for="(item,index) in list" :key="index" class="clear bcw mbm class-card">
      <div class="left class-card__title tac">
          <div class="avatar__img" @click="goHomepage(item.coach.userId)">
            <img v-if="item.coach && item.coach.avatar" :src="item.coach.avatar">
            <i v-else class="iconfont">&#xe6a7;</i>
          </div>
          <van-tag v-if="item.type=='month_card'" type="success" round plain size="mini">月课</van-tag>
          <van-tag v-else type="primary" round plain size="mini">私教</van-tag>
      </div>
      <div class="class-card__info clear fs2 c6">
        <div class="clear">{{item.coach?item.coach.realName:''}}
          <div v-if="item.type=='month_card'" class="right"><i class="iconfont fs4" @click.stop="qrcode(item.orderId,'clubMonthCard')">&#xe63e;</i></div>
          <div v-else class="right"><i class="iconfont fs4" @click.stop="qrcode(item.orderId,'clubPtCourse')">&#xe63e;</i></div>
        </div>
        <div v-if="item.coach" class="green clear fs1 mtn">{{item.coach.title | titleFilter}}</div>      
        <div v-else class="green clear fs1 mtn"></div>      
        <div class="c9 clear fs1 mtn">购买时间：{{item.createdTime | formatTime}}</div>        
        <div class="class-card__foot c6 fs2" @click="goTo(item.id,item.type)">
          <van-icon class="arrows right c6 fs2" name="arrow"/>
          <span class="right">查看课表</span>
        </div>
      </div>
    </div>

    <div v-if="list.length==0" v-show="none" class="tac c9 fs2 ptm pbm">~ 暂无记录 ~</div>
  </div>
  <the-tabbar></the-tabbar>

  <!-- 二维码 -->
  <div id="qrcodeWrap" class="qrcode-wrap" v-show="showcode" @click="cancleQrcode()"><div id="qrcode"></div></div>
</div>
</template>
<script>
import Vue from 'vue';
import func from "@/assets/scripts/func";
import AvatarBox from '@/components/AvatarBox';
import TheTabbar from '@/components/TheTabbar';
import {Toast} from 'vant';
Vue.use(Toast);
import QRCode from 'qrcodejs2'
import moment from 'moment';
moment.locale('zh-cn');

export default {
  components: {
    AvatarBox,TheTabbar
  },
  filters: {
    titleFilter(status) {
      // 教练职称
      const statusMap = {
        assistant: '助教',
        junior: '初级教练',
        intermediate: '中级教练',
        senior: '高级教练'
      }
      return statusMap[status]
    },
    formatTime: function(value) {
      return moment(value*1000).format('YYYY-MM-DD');
    }
  },
  data() {
    return {
      list:[],
      none:false,
      value:'',
      showcode:false
    }
  },
  created(){
    // this.fetchData()
    // 获取私教课列表
    this.$http.post('club_pt_course/getList').then(res => {
      if (!res.data.code) {
        this.list = this.list.concat(res.data.value);            
      } else {
        Toast.fail(res.data.message);
      }
      this.fetchData()
      this.none = true //解决“暂无记录”默认显示的问题
    })

  },
  methods: {
    goHomepage: function(id) {
      location.href =`${location.origin}` + "/training/#/userHome?userId=" + id;
    },
    fetchData(more) {
      // 获取月课列表
      this.$http.post('product/getList',{
        code:'MONTH_CARD'
      }).then(res => {
        if (!res.data.code) {
          this.list = this.list.concat(res.data.value);            
        } else {
          Toast.fail(res.data.message);
        }

        this.none = true //解决“暂无记录”默认显示的问题
      })
    },
    goTo(id,type){
      this.$router.push('/classdetail?id='+id+'&type='+type)
    },
    qrcode (orderId,type) {
      this.showcode = true;
      let qrcode = new QRCode('qrcode', {
          width: 150,
          height: 150, // 高度
          text: `${location.origin}/venue/#/scancodewriteoff?type=order&relateId=${orderId}&targetType=${type}`, // 二维码内容 网址为http或https开头
      })
    },
    cancleQrcode(){
      this.showcode = false;
      document.getElementById('qrcodeWrap').innerHTML='<div id="qrcode"></div>'
    }
  }
}
</script>
<style lang="less">
// 课程信息模块
.mt15{
  margin-top:15px;
}
.class-card {
  padding: .15rem .1rem;
  position: relative;
  display: block;
  &__title {
    width: 0.5rem;
    margin-right: 0.1rem;
  }
  &__info {
    float: left;
    width:calc(100%-0.6rem);
    overflow: hidden;
  }
  &__foot{
    position: absolute;
    right: .05rem;
    bottom: .15rem;
    &>.arrows{
      margin-top: .03rem;
    }
  }
}

.avatar__img{
  float: left;
  width: .4rem;
  height: .4rem;
  margin: 0 0 .05rem .05rem;
  border-radius: 50%;
  overflow: hidden;
  background-color: #f6f6f6;
  position: relative;
  &>img{
    width: 100%;height: 100%;object-fit: cover;
  }
  &>.iconfont{
    color: #ccc;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
  }
}


// 二维码
.qrcode-wrap{
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba(0,0,0,.5);
    z-index: 99;
    color: #fff;
    & #qrcode{
        position: fixed;
        top: 50%;
        left: 50%;
        border: 10px solid #fff;
        transform: translate(-50%, -50%);
        -o-transform: translate(-50%, -50%);
        -moz-transform: translate(-50%, -50%);
        -webkit-transform: translate(-50%, -50%);
        -ms-transform: translate(-50%, -50%);
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/manage/Class.vue